<template>
    <div class="">
        <div v-for="wordResponseApi in wordResponsesApi" :key="wordResponseApi['word']+'-'+wordResponseApi['pos']">
            <WordUI :wordResponseApi="wordResponseApi"/>
        </div>
    </div>
</template>

<script>
    import WordUI from "@/components/dictionary/oxford/WordUI"
    import {lookupOxfordService} from "@/services/dictionary/lookupService"

    export default {
        name: 'word',
        components: {WordUI},
        props: {
            word: {
                type: String
            }
        },
        data: function () {
            return {
                wordResponsesApi: []
            }
        },
        async mounted() {
            await this.renderOxfordData(this.word)
        },
        methods: {
            async renderOxfordData(word) {
                if (word != null) {
                    this.wordResponsesApi = await lookupOxfordService(word)
                }
            }
        },
        watch: {
            word: function (newVal, oldVal) { // watch it
                if (newVal !== oldVal) {
                    this.renderOxfordData(newVal)
                }
            }
        }
    }
</script>

<style>
    @import "../../../assets/css/bootstrap.min.css";
    @import "../../../assets/css/base.css";
    @import "../../../assets/css/colors.css";
    @import "../../../assets/css/font.css";
    @import "../../../assets/css/dictionary.css";

</style>
